/** The one support address shown to users and quoted in server-side messages. */
export const SUPPORT_EMAIL = 'support@recruitallstar.com'
